import { Navigate, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { apiFetch } from "@/config/api";

export default function ProtectedRoute({
  children,
}: {
  children: React.ReactNode;
}) {
  const location = useLocation();
  const [loading, setLoading] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    let mounted = true;

    const checkAuth = async () => {
      try {
        const data = await apiFetch("api_cliente.php", {
          method: "POST",
          body: JSON.stringify({ action: "get" }),
        });

        if (!mounted) return;

        if (data?.cliente) {
          setAuthenticated(true);
        } else {
          setAuthenticated(false);
        }
      } catch (e: any) {
        // 401 = no logueado (NORMAL)
        setAuthenticated(false);
      } finally {
        if (mounted) {
          setLoading(false);
        }
      }
    };

    checkAuth();

    return () => {
      mounted = false;
    };
  }, []);

  // ⏳ Esperando respuesta del backend
  if (loading) {
    return null; // o un loader si quieres
  }

  // ❌ NO AUTENTICADO
  if (!authenticated) {
    return (
      <Navigate
        to="/login"
        replace
        state={{ from: location.pathname }}
      />
    );
  }

  // ✅ AUTENTICADO
  return <>{children}</>;
}
